import { useScriptTag } from '@vueuse/core';
import { isObject } from '@os-web/utils';

const promise = new Promise((resolve) => {
  useScriptTag('https://zxcs.tengzhihh.com/forecastassetbundle/js/bj-report-tryjs.min.js', () => {
    window.BJ_REPORT?.init?.({
      id: 9, //project_code
      uin: 'yiqiwen-sc', //用户标识
      url: '//error.youjyi.cn/api/errrorlog/receive', //上报url
      random: 1, //抽样上报
      offlineLog: false, //是否离线上报
      onReport: function (_id, _errObj) {
        //上报回调
      },
    });

    resolve();
  });
});

export const ErrorReportPlugin = {
  install(app) {
    app.config.errorHandler = async (err, _instance, _info) => {
      console.error(err);
      await promise;

      const { message, name, script = '', line = 0, column = 0, stack } = err;
      const stackStr =
        stack?.toString?.() ||
        (name !== undefined &&
          message !== undefined &&
          name !== 'undefined' &&
          message !== 'undefined' &&
          `${name}:${message}`) ||
        err;

      window.BJ_REPORT.report({
        msg: isObject(stackStr) ? JSON.stringify(stackStr) : stackStr,
        from: window.location.href,
        target: script,
        rowNum: line,
        colNum: column,
      });
    };
  },
};
